import { useTranslation } from "react-i18next";

import { Typography, DropdownItem, Spacer, Skeleton } from "@aviary";
import { BrandLink } from "@emerson/components/BrandLink/BrandLink";
import { l } from "@emerson/locales/i18n";
import type { BrandSplinter } from "@shared/data/queries/BrandsQuery/Brands.query";
import { EmersonSearchApplyFilterEntryPoint } from "@shared/hooks/useAnalyticsLogger/EmersonAnalyticsEntryPoint";

import * as styles from "./FeaturedBrands.styles";

interface Props {
  brands: BrandSplinter[];
  isLoading?: boolean;
}
const FeaturedBrands = ({ brands, isLoading }: Props) => {
  const { t } = useTranslation();

  const renderBrand = (brand: BrandSplinter) => (
    <DropdownItem css={styles.FeaturedBrand} tabIndex={-1} key={brand.id} closeOnItemSelect>
      <BrandLink
        brand={brand}
        entryPoint={EmersonSearchApplyFilterEntryPoint.BRANDS_MENU}
        linkStyles={styles.FeaturedBrandsSpacing}
      >
        <img css={styles.FeaturedBrandsImage} src={brand.logo} alt={brand.name} />
      </BrandLink>
    </DropdownItem>
  );

  const renderBrands = () => {
    if (isLoading) {
      return Array.from({ length: 4 }).map((_, index) => (
        <Skeleton key={index} type="image" height={6.625} isFullWidth />
      ));
    } else return brands.map(brand => renderBrand(brand));
  };

  return (
    <div>
      <Typography type="h5">{t(l.header.Brands.FeaturedBrands)}</Typography>
      <Spacer height="half" />
      <div css={styles.BrandLogosBox}>{renderBrands()}</div>
    </div>
  );
};

export { FeaturedBrands };
